import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export function ShowAlertConfirm(
    title: string, 
    text: string, 
    icon: any, 
    allowOutsideClick: boolean = false, 
    allowEscapeKey: boolean = false, 
    showConfirmButton: boolean = true,
    showCancelButton: boolean = false,
    confirmButtonText: string = 'OK',
    cancelButtonText: string = 'Cancel'
) {
    return withReactContent(Swal).fire({
        title, 
        text, 
        icon, 
        allowOutsideClick, 
        allowEscapeKey, 
        showConfirmButton,
        showCancelButton,
        confirmButtonText,
        cancelButtonText,
        reverseButtons: true
    }).then(result => {
        return result.isConfirmed;
    });
}